/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */

//@todo remove all bootstrap and jquery for the front end if possible (two files - spark.js for spark and app.js)

import Vue from 'vue';
import {store} from './store'
import Vuelidate from 'vuelidate'
import VueAgile from 'vue-agile';
import Paginate from 'vuejs-paginate';

/**
 * Vue-toasted notifications
 */
import Toasted from 'vue-toasted';
Vue.use(Toasted, {
    iconPack : 'material'
});


Vue.use(Vuelidate);
Vue.use(VueAgile);
Vue.component('paginate', Paginate);

require('spark-bootstrap');
require('./components/bootstrap');

var app = new Vue({
    mixins: [require('spark')],
    store,
    data() {
        return {
            linkPrevueApiUrl: process.env.MIX_LINK_PREVUE_API
        }
    }
});



// WEBPACK FOOTER //
// ./resources/js/app.js